import type { Language } from "~/types";

export default {
  en: {
    india: {
      title: 'ETA Authorizations & e-Visas to India • Visanet Blog',
      meta_desc: 'e-Visas and Travel Authorizations for India - ETAs to India, embassy visas, and more info on Indian visas, only on the Visanet Blog'
    },
    israel: {
      title: 'ETA-IL Authorizations & Visas to Israel • Visanet Blog',
      meta_desc: 'e-Visas and Travel Authorizations for Israel - ETA-IL to Israel, embassy visas, and more info on Israeli visas, only on the Visanet Blog'
    },
    news: {
      title: 'News & Updates for Frequent Travelers • Visanet Blog',
      meta_desc: 'Tourism news for frequent travelers – the Visanet blog provides the latest info on e-Visas, ETAs, and travel restrictions worldwide. Subscribe to stay updated!'
    },
    thailand: {
      title: 'ETA Authorizations & e-Visas to Thailand • Visanet Blog',
      meta_desc: 'e-Visas and Travel Authorizations for Thailand - ETAs to Thailand, embassy visas, and more info on Thai visas, only on the Visanet Blog'
    },
    'united-kingdom': {
      title: 'UK ETA to the UK • Visanet Blog',
      meta_desc: 'Travel Authorizations for the UK - UK ETAs to the UK, embassy visas, and more info on British visas, only on the Visanet Blog'
    },
    updates: {
      title: 'Updates & Changes to Travel Authorizations • Visanet Blog',
      meta_desc: 'Updates and changes to travel authorizations - the Visanet blog provides the latest info on e-Visas, ETAs, and travel restrictions worldwide. Subscribe to stay updated!'
    }
  },
  sv: {
    india: {
      title: 'ETA-tillstånd och e-visum till Indien • Visanet Blogg',
      meta_desc: 'E-visum och resetillstånd för Indien - ETA till Indien, ambassadvisum och mer information om indiska visum, endast på Visanet-bloggen'
    },
    israel: {
      title: 'ETA-IL auktorisationer och Visum till Israel • Visanet Blogg',
      meta_desc: 'e-visum och resetillstånd för Israel - ETA-IL till Israel, ambassadvisum och mer information om israeliska visum, endast på Visanet-bloggen'
    },
    canada: {
      title: 'ETA-auktorisationer och e-visum till Kanada • Visanet Blogg',
      meta_desc: 'E-visum och resetillstånd för Kanada - ETA till Kanada, ambassadvisum och mer information om kanadensiska visum, endast på Visanet-bloggen'
    },
    news: {
      title: 'Nyheter och uppdateringar för frekventa resenärer • Visanet-blogg',
      meta_desc: 'Turismnyheter för frekventa resenärer – Visanet-bloggen ger den senaste informationen om e-visum, ETA och resebegränsningar över hela världen. Prenumerera för att hålla dig uppdaterad!'
    },
    'saudi-arabia': {
      title: 'ETA-auktorisationer och e-visum till Saudiarabien • Visanet Blogg',
      meta_desc: 'E-visum och resetillstånd för Saudiarabien - ETA till Saudiarabien, ambassadvisum och mer information om saudiska visum, endast på Visanet-bloggen'
    },
    'sri-lanka': {
      title: 'ETA-auktorisationer och e-visum till Sri Lanka • Visanet Blogg',
      meta_desc: 'E-visum och resetillstånd för Sri Lanka - ETA till Sri Lanka, ambassadvisum och mer information om sri lankesiska visum, endast på Visanet-bloggen'
    },
    'united-kingdom': {
      title: 'UK ETA till Storbritannien • Visanet Blogg',
      meta_desc: 'Resetillstånd för Storbritannien - UK ETA till Storbritannien, ambassadvisum och mer information om brittiska visum, endast på Visanet-bloggen'
    },
    thailand: {
      title: 'ETA-auktorisationer och e-visum till Thailand • Visanet Blogg',
      meta_desc: 'E-visum och resetillstånd för Thailand - ETA till Thailand, ambassadvisum och mer information om thailändska visum, endast på Visanet-bloggen'
    },
    vietnam: {
      title: 'VOA-tillstånd och e-visum till Vietnam • Visanet-blogg',
      meta_desc: 'e-visum och VOA (Visa on Arrival) till Vietnam - ETA till Vietnam, ambassadvisum och mer information om Vietnam-visum, endast på Visanet-bloggen'
    }
  },
  ru: {
    'bali-indonesia': {
      title: 'e-Визы в Индонезию (Бали): Полное руководство • Visanet Блог',
      meta_desc: 'Все об e-визах в Индонезию (Бали): типы e-виз, требования, процесс подачи и полезные советы. Информация от Visanet.'
    },
    news: {
      title: 'Новости для российских путешественников • Блог Визанет',
      meta_desc: 'Новости туризма для россиян – блог Визанет предоставляет свежую информацию о визах, ETA и ограничениях на поездки. Подпишитесь'
    },
    travel: {
      title: 'Советы для российских путешественников • Блог Визанет',
      meta_desc: 'Советы и рекомендации для российских путешественников. Блог Визанет предоставляет свежую информацию о мировых путешествиях и визах'
    },
    israel: {
      title: 'Разрешение на въезд ETA-IL в Израиль • Визанет Блог',
      meta_desc: 'Электронные визы и ETA-IL разрешения на поездки в Израиль – визы через посольство и другая информация о визах в Израиль. Блог Визанет'
    },
    'saudi-arabia': {
      title: 'e-Визы в Саудовскую Аравию: Полное руководство • Visanet Блог',
      meta_desc: 'Все об e-визах в Саудовскую Аравию: типы e-виз, требования, процесс подачи и полезные советы. Информация от Visanet.'
    },
    thailand: {
      title: 'e-Визы в Таиланд: Полное руководство • Visanet Блог',
      meta_desc: 'Все об e-визах в Таиланд: типы e-виз, требования, процесс подачи и полезные советы. Информация от Visanet.'
    },
    togo: {
      title: 'e-Визы в Того: Полное руководство • Visanet Блог',
      meta_desc: 'Все об e-визах в Того: типы e-виз, требования, процесс подачи и полезные советы. Информация от Visanet.'
    },
    india: {
      title: 'Разрешения ETA и электронные визы в Индию • Блог Visanet',
      meta_desc: 'Электронные визы и разрешения на въезд в Индию — электронные визы в Индию, посольские визы и дополнительная информация об индийских визах — только в блоге Visanet'
    },
    'sri-lanka': {
      title: 'Разрешения ETA и электронные визы в Шри-Ланку • Блог Visanet',
      meta_desc: 'Электронные визы и разрешения на поездки в Шри-Ланку — ETA в Шри-Ланку, посольские визы и дополнительная информация о шри-ланкийских визах — только в блоге Visanet'
    },
    korea: {
      title: 'Виза K-ETA в Южную Корею • Блог Визанет',
      meta_desc: 'Электронные визы и K-ETA разрешения на поездки в Южную Корею. Визы через посольство и другая информация о визах в Корею - Визанет'
    },
    vietnam: {
      title: 'VOA разрешения и э-визы во Вьетнам • Блог Визанет',
      meta_desc: 'Электронные визы и VOA (виза по прибытии) во Вьетнам – информация о визах во Вьетнам для россиян, только в блоге Визанет'
    },
    'e-visas': {
      title: 'ETA Визы для российских путешественников • Блог Визанет',
      meta_desc: 'Советы и рекомендации для российских путешественников. Блог Визанет предоставляет свежую информацию о мировых путешествиях и визах'
    }
  },
  he: {
    'אשרות-אמירויות-ודובאי': {
      title: 'אשרות כניסה ויזות אלקטרוניות אמירויות ודובאי • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות לדובאי ואמירויות – כל המידע אודות הנפקת ויזות למטייל הישראלי בחו"ל, זמין כעת באתר ויזה.'
    },
    'us-esta-visas': {
      title: 'קטגוריה: אשרות ארה״ב • Visanet – ויזה.נט',
      meta_desc: 'אשרות כניסה לארה״ב - ויזה ESTA לארצות הברית, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לאמריקה, בלוג ויזה.נט ישראל'
    },
    'uk-eta': {
      title: 'קטגוריה: אשרות בריטניה • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לממלכה המאוחדת: אנגליה, סקוטלנד, ויילס וצפון אירלנד. הנפקת ויזה ללונדון ובריטניה לישראלים - זמין כעת באתר ויזהנט.'
    },
    'south-korea-k-eta': {
      title: 'קטגוריה: אשרות דרום קוריאה • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לדרום קוריאה - K-ETA לדרום קוריאה, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לקוריאה, בלוג ויזה.נט ישראל'
    },
    'india-visas': {
      title: 'אשרות הודו - כל המידע על אשרות כניסה להודו • Visanet – ויזה.נט',
      meta_desc: 'באתר ויזה נט תוכלו להנפיק ויזות ואשרות כניסה לחו"ל ללא הצורך לצאת מהבית או לבקר בשגרירות, במחירים הזולים בישראל! בקרו באתר למידע על אשרות הודו והתחילו בתהליך אונליין.'
    },
    'vietnam-visas': {
      title: 'קטגוריה: אשרות וייטנאם • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לווייטנאם - ויזה אלקטרונית לווייטנאם, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לווייטנאם, בלוג ויזה.נט ישראל'
    },
    'israel-eta-il': {
      title: 'קטגוריה: אשרות ישראל • Visanet – ויזה.נט',
      meta_desc: 'אשרות כניסה לישראל – ויזה ETA-IL לישראל, ללא צורך לבקר בשגרירות. מידע נוסף אודות ויזות לישראל זמין בבלוג של ויזה.'
    },
    'אשרות-לניו-זילנד': {
      title: 'קטגוריה: אשרות לניו זילנד • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לניו זילנד - eTA לניו זילנד, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לניו זילנד, בלוג ויזה.נט ישראל'
    },
    'אשרות-מרוקו': {
      title: 'קטגוריה: אשרות מרוקו • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה למרוקו - ויזה אלקטרונית למרוקו, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות למרוקו, בלוג ויזה.נט ישראל'
    },
    'sri-lanka-visas': {
      title: 'קטגוריה: אשרות סרי לנקה • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לסרי לנקה - ETA לסרי לנקה, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לסרי לנקה, בלוג ויזה.נט ישראל'
    },
    'cambodia-visas': {
      title: 'קטגוריה: אשרות קמבודיה • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לקמבודיה - eVisa לקמבודיה, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לקמבודיה, בלוג ויזה.נט ישראל'
    },
    'canada-visas': {
      title: 'קטגוריה: אשרות קנדה • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות ואשרות כניסה לקנדה - eTA לקנדה, ויזה פיזית בשגרירות, ומידע נוסף אודות ויזות לקנדה, בלוג ויזה.נט ישראל'
    },
    'thailand-visas': {
      title: 'קטגוריה: אשרות תאילנד • Visanet – ויזה.נט',
      meta_desc: 'אשרות ויזה לתאילנד – ויזת DTV ארוכת טווח לתאילנד, ויזה פיזית בשגרירות, הארכת ויזה בתאילנד, ויזה אלקטרונית אונליין לבנגקוק, פוקט, פטאיה, צ\'יאנג מאי ומגוון יעדים…'
    },
    'important-messages': {
      title: 'הודעות חשובות בנושאי ויזות ואשרות כניסה לחו"ל • Visanet – ויזה.נט',
      meta_desc: 'הודעות חשובות בנושאי ויזות ואשרות כניסה לחו"ל הנוגעים לתיירים ישראלים ברחבי העולם. ויזה.נט דואג לעדכן אתכם בחדשות והודעות הכי חשובות בזמן אמת באתר ובבלוג.'
    },
    'e-visas': {
      title: 'מידע אודות ויזות אלקטרוניות ואשרות כניסה • Visanet – ויזה.נט',
      meta_desc: 'ויזות אלקטרוניות, אשרות כניסה, eVisa, eTA - בלוג ויזה.נט עושה לכם סדר בבלאגן ומרכז את כל המידע הכי עדכני וקריטי בנושאי ויזות למגוון מדינות - הודו, מרוקו, קנדה, ועוד'
    },
    news: {
      title: 'חדשות תיירות למטייל הישראלי • Visanet – ויזה.נט',
      meta_desc: 'חדשות תיירות למטייל הישראלי - בלוג ויזה.נט עוזר לכם עם הבירוקרטיה של עולם התיירות ומספק לכם את המידע הכי עדכני בנושאי אשרות כניסה, ויזות אלקטרוניות והגבלות תעופה'
    },
    tourism: {
      title: 'מידע ומדריכים לתייר והמטייל הישראלי • Visanet – ויזה.נט',
      meta_desc: 'מידע ומדריכים לתייר הישראלי - בלוג ויזה.נט מספק לכם את הטיפים הכי עדכניים בנושאי תיירות לחו"ל, ויזות אלקטרוניות, הגבלות תנועה מרחבי העולם, ועוד - הישארו מעודכנים!'
    }
  }
} satisfies Record<Language, Record<string, { title: string; meta_desc: string }>>;